export default __webpack_public_path__ + "static/media/home-image3.c56e27fd.png";